import { Box, Typography } from '@material-ui/core'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined'
import QueryBuilderOutlinedIcon from '@material-ui/icons/QueryBuilderOutlined'
import { useState } from 'react'

import { Tags } from '@/components/tags'
import { InfestationReport } from '@/hooks/queries/use-get-infestation-reports'

import { Modal } from '../components/modal'
import { useStyles } from './styles'

export interface RowProps {
  row: InfestationReport
}

export function Row({ row }: RowProps) {
  const classes = useStyles()
  const [openModal, setOpenModal] = useState(false)

  function handleCloseModal() {
    setOpenModal(false)
  }

  const STATUS_MAP = {
    completed: {
      color: classes.greenLabel,
      icon: <CheckCircleOutlinedIcon />,
    },
    processing: {
      color: classes.orangeLabel,
      icon: <QueryBuilderOutlinedIcon />,
    },
  }
  const statusMap =
    STATUS_MAP[row.status?.status_key as keyof typeof STATUS_MAP]

  return (
    <>
      <TableRow className={classes.row} onClick={() => setOpenModal(true)}>
        <TableCell>
          <Typography variant='subtitle1'>{row.created_at}</Typography>
        </TableCell>
        <TableCell>
          <Typography variant='subtitle1'>{row.name}</Typography>
        </TableCell>
        <TableCell>
          <Typography variant='subtitle1'>
            {`${row.initial_conclusion_date} - ${row.final_conclusion_date}`}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography variant='subtitle1'>{row.requester.name}</Typography>
        </TableCell>
        <TableCell>
          <Box display='flex' gridGap='1rem'>
            {row.cultures.map((culture) => (
              <Tags key={culture} culture={culture} />
            ))}
          </Box>
        </TableCell>
        <TableCell className={classes.statusCell}>
          <div className={statusMap?.color}>
            <span>{statusMap?.icon}</span>
            {row.status?.label}
          </div>
        </TableCell>
      </TableRow>
      <Modal row={row} open={openModal} onClose={handleCloseModal} />
    </>
  )
}
